import React, { MouseEventHandler, useCallback, useMemo, useRef, useState } from "react";

import { Button, Stack, Typography } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { MRT_Column, MRT_TableInstance } from "material-react-table";

import { useRenderDateValue } from "../../../hooks";
import { ClientDealTableRow, DealTableColumn, ReportTableColumn } from "../../../store/types";

type Props = {
  column: MRT_Column<ClientDealTableRow>;
  table: MRT_TableInstance<ClientDealTableRow>;
  onClick: MouseEventHandler;
};

export const TableHeader = ({ column, table, onClick }: Props) => {
  const { def: colDef, data: colData } = column.columnDef.meta as { def: ReportTableColumn; data: DealTableColumn };

  const previewDate = useRenderDateValue();

  const otherColumns = table.getAllColumns().filter((col) => col !== column);

  const drText = !colDef.dateRange ? "" : previewDate(colDef.dateRange);
  const currencyText: string = !colDef.currency ? "" : colDef.currency;
  const buttonText =
    drText || currencyText
      ? `${drText}, ${currencyText === "ORIGINAL" ? "Original Currency" : currencyText}`
      : "Default";
  const showButton =
    (!!colDef.dateRange ||
      //@ts-ignore
      otherColumns.some((col) => col.columnDef.meta?.def?.aggregation === colDef.aggregation)) &&
    colData.key !== "Secondary Pricing";

  const tooltipTitle = useMemo(() => {
    if (colData.key === "DPI") {
      return "Distributions / Capital Calls";
    }
    if (colData.key === "MOIC") {
      return "Distributions + Nav / Capital calls";
    }

    return "";
  }, [colData.key]);

  const textRef = useRef<HTMLElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const handleMouseEnter = useCallback(() => {
    const el = textRef.current;
    if (el) setIsTruncated(el.scrollWidth > el.clientWidth);
  }, []);

  return (
    <Stack alignItems="flex-start">
      <MaterialTooltip title={tooltipTitle || colData.title} isShow={!!tooltipTitle || isTruncated} placement="top">
        <Typography ref={textRef} width="100%" noWrap onMouseEnter={handleMouseEnter}>
          {colData.title}
        </Typography>
      </MaterialTooltip>
      {showButton && (
        <Button
          size="sm"
          variant="text"
          sx={{ position: "relative", left: "-7px", minWidth: 40, color: "#496682" }}
          onClick={onClick}
        >
          {buttonText}
        </Button>
      )}
    </Stack>
  );
};
